import { render, staticRenderFns } from "./daily.vue?vue&type=template&id=070f2e1d&scoped=true"
import script from "./daily.vue?vue&type=script&lang=js"
export * from "./daily.vue?vue&type=script&lang=js"
import style0 from "./daily.vue?vue&type=style&index=0&id=070f2e1d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070f2e1d",
  null
  
)

export default component.exports